import * as React from 'react';
import {
    Avatar,
    Checkbox, IconButton,
    makeStyles, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography
} from "@material-ui/core";
import CommentIcon from '@material-ui/icons/Comment';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import DeleteIcon from '@material-ui/icons/Delete';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CustomSkeleton from "../../components/CustomSkeleton";

let defaultLoadingLines = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 650,
    },
    image: {
        height: 40,
    },
    avatarContainer: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    picked: {
        color: "green"
    }
}));

export default function InvoiceDetailLines(props) {
    const {
        detailLines,
        isPickupLineSelected,
        showActionButtons,
        handlePickupLineClick,
        handleCommentBtnClick,
        getLineComment,
        getLineSupportingImage,
        handleCameraBtnClick,
        removeSupportingImage,
        handleHeaderCheckBoxClick,
        headerCheckedStatus,
        displayHeaderCheckbox,
        loading,
        displayItemCodeField,
        displayPriceField,
    } = props;

    const classes = useStyles();

    return (

        <div>
            <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="pickup detail table">
                    <TableHead>
                        <TableRow>
                            {displayHeaderCheckbox ?
                                <TableCell><Checkbox checked={headerCheckedStatus()}
                                                     onClick={(event) => {
                                                         handleHeaderCheckBoxClick(event)
                                                     }}
                                /></TableCell>
                                : null}
                            {displayItemCodeField && <TableCell>Item </TableCell>}
                            <TableCell>Description</TableCell>
                            <TableCell align='right'>Quantity</TableCell>
                            {displayPriceField && <TableCell align='right'>Price</TableCell>}
                            <TableCell width='16%'>Comment</TableCell>
                            <TableCell>Picture</TableCell>
                            <TableCell width='24%'>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {loading ?
                            (
                                defaultLoadingLines.map(lineKey => {
                                    return <TableRow key={lineKey}>
                                        {displayItemCodeField && <TableCell><CustomSkeleton/></TableCell>}
                                        <TableCell><CustomSkeleton width='100%'/> </TableCell>
                                        {displayPriceField && <TableCell> <CustomSkeleton width='40%'/> </TableCell>}
                                        <TableCell><CustomSkeleton width='40%'/></TableCell>
                                        <TableCell><CustomSkeleton width='60%'/> </TableCell>
                                        <TableCell><CustomSkeleton width='60%'/></TableCell>
                                        <TableCell>{null}</TableCell>
                                        <TableCell>
                                            {null}
                                        </TableCell>

                                    </TableRow>
                                })) :

                            (detailLines && detailLines.length > 0 ? detailLines.map((detailLine) => {
                                const showActionsButtons = showActionButtons(detailLine.id);
                                const isLineSelected = isPickupLineSelected(detailLine.id);
                                const comment = getLineComment(detailLine.id)
                                const lineImage = getLineSupportingImage(detailLine.id)
                                return (
                                    <TableRow key={detailLine.id}
                                              role="checkbox"
                                              selected={isLineSelected && showActionsButtons}
                                    >
                                        {displayHeaderCheckbox ?
                                            <TableCell> {showActionsButtons ?
                                                <Checkbox checked={isLineSelected}
                                                          onClick={(event) => handlePickupLineClick(event, detailLine.id)}/>
                                                : null}  </TableCell> : null
                                        }
                                        {
                                            displayItemCodeField && <TableCell component="th"
                                                                               scope="detailLine">{detailLine.item !== '/C' && detailLine.item !== '/F' ? detailLine.item : null}</TableCell>
                                        }
                                        <TableCell>{detailLine.description}</TableCell>
                                        <TableCell
                                            align="right">{detailLine.item === '/C' ? '' : (detailLine.quantity)} </TableCell>
                                        {
                                            displayPriceField &&
                                            <TableCell
                                                align="right">{detailLine.item === '/C' ? '' : ('$' + detailLine.extension.toFixed(2))} </TableCell>
                                        }
                                        <TableCell size='small'>{comment}</TableCell>
                                        <TableCell>{
                                            lineImage ?
                                                <div className={classes.avatarContainer}>
                                                    {
                                                        detailLine.alreadyAccepted ?
                                                            <Avatar style={{'cursor': 'pointer'}}
                                                                    variant='circular'>
                                                                <img className={classes.image} src={lineImage}
                                                                     alt='Supporting proof'/>
                                                            </Avatar>
                                                            :
                                                            <>
                                                                <Avatar style={{'cursor': 'pointer'}}
                                                                        variant='circular'
                                                                        onClick={(event) => handleCameraBtnClick(event, detailLine.id)}>
                                                                    <img className={classes.image} src={lineImage}
                                                                         alt='Supporting proof'/>
                                                                </Avatar>
                                                                <IconButton aria-label="delete"
                                                                            onClick={(event) => removeSupportingImage(event, detailLine.id)}>
                                                                    <DeleteIcon/>
                                                                </IconButton>
                                                            </>
                                                    }

                                                </div>
                                                : null
                                        }</TableCell>
                                        <TableCell>
                                            {showActionsButtons ?
                                                (<div>
                                                    <IconButton
                                                        onClick={(event) => handleCommentBtnClick(event, detailLine.id)}>
                                                        <CommentIcon/>
                                                    </IconButton>
                                                    <IconButton
                                                        onClick={(event) => handleCameraBtnClick(event, detailLine.id)}>
                                                        <PhotoCameraIcon/>
                                                    </IconButton>
                                                </div>)
                                                : null}
                                            {detailLine.alreadyAccepted ? <><IconButton disabled>
                                                <CheckCircleIcon className={classes.picked} fontSize="inherit"/>
                                            </IconButton>
                                                <Typography variant='body2' display='inline'>Picked up
                                                    on {detailLine.formattedPickupDate}</Typography>
                                            </> : null}
                                        </TableCell>

                                    </TableRow>
                                )

                            }) : <TableRow>
                                <TableCell colSpan={displayHeaderCheckbox ? 8 : 7} align='center'>
                                    No records found
                                </TableCell>
                            </TableRow>)}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
}
